import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTheme, alpha } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import useWindowDimensions from '../../_common/WindowDimesnions'
import constants from '../../../config/constants'
import defaultTexts from '../../../texts/texts'
import { setProgressStep, setSubscriptionPackage, setSubscriptionRenewable } from '../../../store/reducers/subscriptionAddSlice'
import CustomSlickSlider from '../../_common/CustomSlickSlider'
import SubscriptionItem from './SubscriptionItem'

const SelectSubscriptionWrapper = (props) => {
  const {
    setStep,
    subscriptionPackagesData,
    subscriptionPackages,
    setSubscriptionPackages,
  } = props
  const { width } = useWindowDimensions()
  const theme = useTheme()
  const dispatch = useDispatch()
  
  const group = useSelector(state => state.subscriptionAdd.group)

  const [subscriptionsSliderData, setSubscriptionsSliderData] = useState([])
  const [subscriptionsSliderSlidesToShow, setSubscriptionsSliderSlidesToShow] = useState(0)
  const [allowNext, setAllowNext] = useState(false)

  const subscriptionSliderArrows = {
    leftIcon: <ArrowBackIcon fontSize='large' />,
    rightIcon: <ArrowForwardIcon fontSize='large' />,
    leftStyle: {
      width: '50px',
      height: '50px',
      border: `${theme.palette.oxfordBlue} 2px solid`,
      borderRadius: '25px',
      color: theme.palette.oxfordBlue,
      position: 'absolute',
      top: '45%',
      left: '-50px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },    
    rightStyle: {
      width: '50px',
      height: '50px',
      border: `${theme.palette.oxfordBlue} 2px solid`,
      borderRadius: '25px',
      color: theme.palette.oxfordBlue,
      position: 'absolute',
      top: '45%',
      right: '-50px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }

  const nextButtonStyle = {
    fontWeight: '400',
    color: 'white',
    background: theme.palette.violetsAreBlue,
    fontSize: '18px',
    height: '44px',
    borderRadius: '22px',
    padding: '0px 40px',

    '&:hover': {
      background: alpha(theme.palette.violetsAreBlue, 0.8),
    },

    '&:disabled': {
      background: theme.palette.grayX11,
      color: 'white',
    },
  }

  const handleClickPrev = () => {
    setStep(1)
    dispatch(setProgressStep({ progress_step: 1 }))
  }

  const getSelectedSubscriptionId = () => {
    const subscription_object = subscriptionPackages.find(item => item.checked)
    return subscription_object ? subscription_object.id : null
  }

  const getSelectedSubscriptionRenewable = () => {
    const subscription_object = subscriptionPackages.find(item => item.checked)
    return subscription_object ? subscription_object.renewable : false
  }

  const getSelectedSubscriptionServices = () => {
    const subscription_object = subscriptionPackages.find(item => item.checked)
    return subscription_object ? subscription_object.services : []
  }

  const getSelectedSubscriptionPackageName = () => {
    const subscription_package = subscriptionPackages.find(item => item.checked)
    return subscription_package ? subscription_package.package_name : ''
  }

  const getSelectedServices = () => {
    let result = []

    const selected_subscription_id = getSelectedSubscriptionId()
    const selected_subscription_services = getSelectedSubscriptionServices()

    const subscription_data_object = subscriptionPackagesData.find(item => item.id === selected_subscription_id)

    if (subscription_data_object && subscription_data_object.services) {
      subscription_data_object.services.forEach(s => {
        if (s.is_mandatory) {
          result.push(s)
        } else {
          const selected_service_object = selected_subscription_services.find(item => item.service === s.service && item.checked)
          if (selected_service_object) {
            result.push(s)
          }
        }
      })
    }

    return result
  }

  const handleClickNext = () => {
    let next_step = 3

    if (group === 'isender') {
      next_step = 4
    }

    setStep(next_step)

    dispatch(setProgressStep({ progress_step: next_step }))

    dispatch(setSubscriptionPackage({
      subscription_package: {
        id: getSelectedSubscriptionId(),
        name: getSelectedSubscriptionPackageName(),
        services: getSelectedServices(),
      }
    }))

    dispatch(setSubscriptionRenewable({ subscription_renewable: getSelectedSubscriptionRenewable() }))
  }

  useEffect(() => {
    if (subscriptionPackages.length > 0) {
      let subscription_slider_data = []

      subscriptionPackages.forEach((item, index) => {
        subscription_slider_data.push(<SubscriptionItem
          key={index}
          {...item}
          setSubscriptionPackages={setSubscriptionPackages}
        />)
      })

      setSubscriptionsSliderData(subscription_slider_data)

      let slides_to_show = 3

      if (width < constants.mdBreakpoint) {
        slides_to_show = 1
      } else if (width < constants.lgBreakpoint) {
        slides_to_show = 2
      } else if (subscriptionPackages.length < 3) {
        slides_to_show = subscriptionPackages.length
      }

      setSubscriptionsSliderSlidesToShow(slides_to_show)
    } else {
      setSubscriptionsSliderData([])
      setSubscriptionsSliderSlidesToShow(0)
    }
  }, [
    subscriptionPackages,
    setSubscriptionPackages,
    width,
  ])

  useEffect(() => {
    const subscription_object = subscriptionPackages.find(item => item.checked)
    setAllowNext(subscription_object ? true : false)
  }, [subscriptionPackages])
  
  return (
    <>
      <Box sx={{ margin: '40px 0px 20px 0px' }}>
        {
          subscriptionsSliderData.length > 0 &&
          <CustomSlickSlider
            slides={subscriptionsSliderData}
            arrows={subscriptionSliderArrows}
            slidesToShow={subscriptionsSliderSlidesToShow}
            draggable={true}     
            centerMode={width < constants.mdBreakpoint ? true : false}
            sx={{ margin: width >= constants.mdBreakpoint ? '0px 50px' : '0px' }}
          />
        }
      </Box>

      <Stack
        direction='row'
        justifyContent='space-between'
      >
        <Button
          variant='text'
          disableRipple
          disableElevation
          sx={nextButtonStyle}
          onClick={handleClickPrev}
        >
          {defaultTexts.back}
        </Button>
        <Button
          variant='text'
          disableRipple
          disableElevation
          disabled={allowNext ? false : true}
          sx={nextButtonStyle}
          onClick={handleClickNext}
        >
          {defaultTexts.next}
        </Button>
      </Stack>
    </>
    
  )
}

export default SelectSubscriptionWrapper